import { render, staticRenderFns } from "./ItemLocationList.vue?vue&type=template&id=97707c0c&scoped=true&"
import script from "./ItemLocationList.vue?vue&type=script&lang=js&"
export * from "./ItemLocationList.vue?vue&type=script&lang=js&"
import style0 from "./ItemLocationList.vue?vue&type=style&index=0&id=97707c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97707c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97707c0c')) {
      api.createRecord('97707c0c', component.options)
    } else {
      api.reload('97707c0c', component.options)
    }
    module.hot.accept("./ItemLocationList.vue?vue&type=template&id=97707c0c&scoped=true&", function () {
      api.rerender('97707c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemLocations/ItemLocationList.vue"
export default component.exports